import React, { useState, useEffect } from "react";
import Box from "../components/ui-kit/box";
import "./Blog.scss";

import updateMetaTags from "../helpers/meta";
import { translateString } from "../helpers/translator";

const fetchArticle = async (id) => {
  try {
    const response = await fetch(
      `https://hosting.azasoftware.com/wp-json/wp/v2/posts/?slug=${id}`
    );

    return await response.json();
  } catch (error) {
    console.error("Error fetching article:", error);
  }
};

const Article = ({ id, language }) => {
  const [article, setArticle] = useState(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const getArticle = async () => {
      try {
        const result = await fetchArticle(id);
        setArticle(result[0]);
      } catch (e) {
        setArticle(null);
      }
      setHasLoaded(true);
    };

    getArticle();
  }, [id]);

  useEffect(() => {
    if (!hasLoaded) {
      updateMetaTags({
        title: "Loading Article - Aza Software",
        description: "Loading article content...",
        keywords: "software development, tech articles",
      });
      return;
    }

    if (!article) {
      updateMetaTags({
        title: "404 Not Found - Aza Software",
        description: "Article not found",
        keywords: "software development, tech articles",
      });
      return;
    }

    const plainText =
      article.content.rendered.replace(/<[^>]+>/g, "").substring(0, 160) +
      "...";

    updateMetaTags({
      title: `${article.title.rendered} - Aza Software`,
      description: plainText,
      keywords:
        article.tags?.join(", ") || "software development, tech articles",
      image:
        article.featured_media_url ||
        "https://azasoftware.com/images/preview.png",
    });
  }, [article, hasLoaded]);

  if (!hasLoaded) {
    return (
      <div className="blog-page">
        <div className="container">
          <Box className={`blog `}>
            <h1>{translateString("ARTICLE.HEADER.loading", language)}</h1>
          </Box>
        </div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="blog-page">
        <div className="container">
          <Box className={`blog `}>
            <h1>{translateString("ARTICLE.HEADER.notFound", language)}</h1>
          </Box>
        </div>
      </div>
    );
  }

  
  return (
    <div className="blog-page">
      <div className="container">
        <Box className={`blog `}>
          <h1>{article?.title?.rendered}</h1>
          <article className="article">
            <main
              dangerouslySetInnerHTML={{ __html: article?.content?.rendered }}
            />
          </article>
        </Box>
      </div>
    </div>
  );
};

export default Article;
